import { createStore } from 'vuex'
import { user } from '@/store/modules/user'
import global from '@/store/modules/global'

export default createStore({
  state: {},
  mutations: {},
  actions: {},
  modules: { user, global }
})
